














































































import {Component, Vue, Prop, Mixins, Watch} from 'vue-property-decorator';
import {CreditCard as CreditCardType} from "@/types/CheckoutFormData";
import MaskedInput from "vue-masked-input";
import NiceSelect from "./NiceSelect.vue";
import {Mixin} from "@/mixins";
import store from '@/store';

@Component({
    components: {
        MaskedInput,
        NiceSelect
    },
    name: "CreditCard",
})
export default class CreditCard extends Mixins(Mixin) {
    store = store();

    number = '';

    get months() {
        let ret: { [key: string]: string } = {
            '': 'MM'
        };
        let firstMonth = 1;
        if (this.store.formData.creditCard.expiration.year === (new Date()).getFullYear().toString()) {
            firstMonth = (new Date()).getMonth() + 1;
        }
        for (let i = firstMonth; i < 13; i++) {
            let str = i.toString();
            let key = str.length === 1 ? '0' + str : str;
            ret[key] = str;
        }
        return ret;
    }

    get years() {
        let ret: { [key: string]: string } = {
            '': 'JJJJ'
        };
        let curYear = (new Date()).getFullYear();
        for (let i = curYear; i < curYear + 20; i++) {
            let str = i.toString();
            ret[str.substring(2)] = str;
        }
        return ret;
    }

    created() {
        this.number = this.store.formData.creditCard.number;
    }

    @Watch('number')
    onNumberChange() {
        this.store.formData.creditCard.number = this.number.replace(/-|\s/g, '');
    }
}
